const portfolioData = {
  personalInfo: {
    name: "Diego Mendoza",
    title: "Cloud & DevOps Engineer | Multi-Cloud & DevSecOps",
    email: "diego.mendozab@outlook.com",
    github: "https://github.com/diegomdzbz",
    avatar: "/diego-avatar.jpg",
    linkedin: "https://www.linkedin.com/in/diegmb/",
    location: "Mexico City, Mexico (Remote / Hybrid)"
  },
  aboutMe:
    "Cloud & Software Engineer with 5+ years designing secure, scalable multi-cloud architectures across AWS, Azure, and GCP. Strong DevSecOps focus — containerized deployments with Docker, Kubernetes, and Helm, backed by hands-on IAM, Kubernetes RBAC, and secrets management. Framework-agnostic and AI-driven, translating complex business needs into reliable, production-grade solutions. Based in Mexico City — open to Remote / Hybrid roles.",
  experience: [
    {
      id: 1,
      role: "Cloud Engineer & Back End Developer",
      company: "Capgemini México · client: BBVA",
      period: "Jun 2026 - Present",
      description:
        "Contribute to a cross-functional backend team at BBVA, integrating AI-driven capabilities into a large-scale banking environment. Build APIs and backend services in Python connecting LLMs, frontend apps, and data sources, designing and consuming RESTful APIs. Deploy and manage cloud infrastructure on AWS applying DevSecOps practices, and contribute to automated testing and service integrations within a cloud-based architecture.",
      skills: [
        "Python",
        "AWS",
        "REST APIs",
        "LLM Integration",
        "DevSecOps",
        "GitHub Enterprise",
        "Agile / Scrum",
        "Testing"
      ]
    },
    {
      id: 2,
      role: "Software Engineer",
      company: "Zulunity",
      period: "Mar 2025 - May 2026",
      description:
        "Improved delivery reliability by designing and monitoring CI/CD pipelines in Jenkins and Infrastructure as Code, with secrets management via AWS Secrets Manager. Managed Helm Charts with Kubernetes RBAC under least-privilege policies, implemented IAM roles across AWS, Azure and GCP, and led project migrations to GitHub Enterprise and GitLab preserving full source code integrity.",
      skills: [
        "Jenkins",
        "Terraform",
        "Kubernetes",
        "Helm",
        "Docker",
        "AWS",
        "Azure",
        "GCP",
        "IAM & RBAC",
        "JFrog",
        "CI/CD"
      ]
    },
    {
      id: 3,
      role: "Junior Software Engineer",
      company: "Zulunity",
      period: "Jun 2024 - Feb 2025",
      description:
        "Took full ownership of the application lifecycle, integrating Full Stack practices within a DevOps culture. Contributed to deployment automation, monitoring and observability while ramping up on enterprise tooling (Jenkins, Helm, JFrog, GitHub Enterprise).",
      skills: ["SDLC", "DevOps", "Full Stack", "Monitoring", "Observability"]
    },
    {
      id: 4,
      role: "Full Stack & Cloud/DevOps Engineer",
      company: "Independent / Freelance",
      period: "Jan 2021 - May 2024",
      description:
        "Delivered end-to-end Full Stack applications from architecture to deployment, owning the complete product lifecycle for client and personal projects. Streamlined delivery by building and automating CI/CD pipelines and cloud deployments on GCP and AWS using Infrastructure as Code, and reduced operational overhead by managing containerized workloads with DevOps and security best practices.",
      skills: [
        "Full Stack",
        "GCP",
        "AWS",
        "Terraform",
        "Docker",
        "CI/CD",
        "React",
        "Node.js"
      ]
    }
  ],
  education: [
    {
      id: 1,
      degree:
        "Bachelor of Engineering - BE, Artificial Intelligence and Data Science",
      institution: "Universidad Tecnológica de México (UNITEC)",
      period: "Mar 2026 - Mar 2029",
      description:
        "Engineering focused on optimizing intelligent systems, cloud solution architecture, and the deployment of machine learning models. Focusing on Data Science, Ethics, and AI Infrastructure."
    },
    {
      id: 2,
      degree: "Bachelor of Science - B.S., Nutrition Sciences",
      institution: "Universidad ICEL",
      period: "Jun 2019 - Jun 2023",
      description:
        "Completed degree prior to moving full-time into software engineering. Built the analytical and data-driven mindset later applied to backend systems and cloud infrastructure."
    }
  ],
  certifications: [
    {
      id: 1,
      name: "Microsoft Certified: Azure Fundamentals",
      issuer: "Microsoft",
      date: "Aug 2021",
      credentialUrl: "#"
    },
    {
      id: 2,
      name: "Introduction to Software Engineering",
      issuer: "IBM",
      date: "2026",
      credentialUrl: "#"
    },
    {
      id: 3,
      name: "Introduction to AWS: Cloud Computing Fundamentals",
      issuer: "Platzi",
      date: "2024",
      credentialUrl: "#"
    },
    {
      id: 4,
      name: "AI for Research and Insights",
      issuer: "Google",
      date: "Mar 2026",
      credentialUrl: "#"
    },
    {
      id: 5,
      name: "AI for Brainstorming and Planning",
      issuer: "Google",
      date: "Mar 2026",
      credentialUrl: "#"
    },
    {
      id: 6,
      name: "AI for Writing and Communicating",
      issuer: "Google",
      date: "Mar 2026",
      credentialUrl: "#"
    }
  ],
  skills: [
    "Terraform",
    "Kubernetes",
    "Docker",
    "Helm",
    "AWS",
    "Azure",
    "GCP",
    "Jenkins",
    "CI/CD",
    "Python",
    "DevSecOps",
    "Infrastructure as Code"
  ]
};

export default portfolioData;
